import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import './Pricing.css'; // Reuse existing styles

const SubscriptionSuccessPage: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');

    useEffect(() => {
        // We could verify session_id with backend if critical, 
        // but webhook handles the actual fulfillment.
        // Just show success message and redirect.

        const timer = setTimeout(() => {
            navigate('/dashboard');
        }, 5000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="pricing-container" style={{ justifyContent: 'center', textAlign: 'center' }}>
            <div className="pricing-card" style={{ maxWidth: '500px', margin: '0 auto' }}>
                <div style={{ fontSize: '4rem', marginBottom: '20px' }}>🎉</div>
                <h1>Payment Successful!</h1>
                <p style={{ fontSize: '1.2rem', color: '#666', margin: '20px 0' }}>
                    Thank you for upgrading to Pro! Your subscription is now active.
                </p>
                <p>You will be redirected to your dashboard in 5 seconds...</p>
                <button
                    className="cta-button"
                    onClick={() => navigate('/dashboard')}
                    style={{ marginTop: '30px' }}
                >
                    Go to Dashboard Now
                </button>
            </div>
        </div>
    );
};

export default SubscriptionSuccessPage;
